webpackJsonp([114276838955818,60335399758886],{

/***/ 170:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(170);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _data = __webpack_require__(12);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _designSystem = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = _data2.default.name,
	    title = _data2.default.title,
	    description = _data2.default.description,
	    img = _data2.default.img,
	    url = _data2.default.url,
	    org = _data2.default.org;
	
	
	var meta = function meta(tags) {
	  return tags.map(function (props, index) {
	    return _react2.default.createElement('meta', _extends({}, props, { key: index }));
	  });
	};
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _designSystem.ThemeProvider,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: title, title: title },
	      _react2.default.createElement('html', { lang: 'en' }),
	      _react2.default.createElement('meta', { charSet: 'UTF-8' }),
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width,initial-scale=1' }),
	      _react2.default.createElement('meta', { name: 'format-detection', content: 'telephone=no' }),
	      _react2.default.createElement('link', { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }),
	      _react2.default.createElement('meta', { name: 'theme-color', content: _designSystem.colors.primary }),
	      meta([{ name: 'description', content: description }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:description', content: description }, { name: 'twitter:domain', content: url }, { name: 'twitter:image:src', content: img }, { name: 'twitter:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: img }, { property: 'og:image:height', content: 512 }, { property: 'og:image:width', content: 512 }, { property: 'og:locale', content: 'en_US' }, { property: 'og:site_name', content: name }, { property: 'og:title', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: url }]),
	      _react2.default.createElement('script', { type: 'application/ld+json', children: JSON.stringify(org) })
	    ),
	    props.children()
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f7bd4fed4e8d1c7b490b.js